import { Component, OnInit, Type } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ServiceNowPairingComponent } from "./pair/svcnow-pairing.component";
import { EmsPairingComponent } from "./pair/ems-pairing.component";

@Component({
    selector: 'app-pairing-loader',
    // You just need a simple, self-closing component tag for the dynamic component
    template: '<ng-container *ngComponentOutlet="selectedComponentType"></ng-container>',
    standalone: false
})
export class PairingLoaderComponent implements OnInit {
    selectedComponentType: Type<any> | undefined;

    private componentMap: { [key: string]: Type<any> } = {
        'svcnow': ServiceNowPairingComponent,
        'ems': EmsPairingComponent,
    };

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        // Access the parent route's parameters to get the ':brand'
        this.route.parent!.paramMap.subscribe(params => {
            const brand = params.get('brand')!.toLowerCase();
            this.selectedComponentType = this.componentMap[brand];

            if (!this.selectedComponentType) {
                console.error(`Unknown brand segment: ${brand}. Cannot load 3rd app pairing component.`);
                // Optionally, redirect to a 404 or default component
            }
        });
    }

}